import {
  Breadcrumbs,
  type BreadcrumbsProps,
  CircularProgress,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { Link } from "@tanstack/react-router";
import { BaseIcon } from "../BaseIcons";

export type BaseBreadCrumbProps = {
  isLoading?: boolean;
  links: {
    label: string;
    href?: string;
  }[];
} & BreadcrumbsProps;

export const BaseBreadCrumb = ({ links, ...props }: BaseBreadCrumbProps) => {
  if (props.isLoading) {
    return <CircularProgress size={16} />;
  }
  const { isLoading, ...restProps } = props;
  const isLast = links.length - 1;
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={
        <BaseIcon
          name="chevronRight"
          htmlColor={grey[300]}
          sx={{ fontSize: "20px" }}
        />
      }
      {...restProps}
    >
      {links.map((link, index) => {
        const isDisabled = !link.href || index === isLast;
        return (
          <Typography
            key={link.label}
            disabled={isDisabled}
            component={Link}
            to={link.href}
            color={isDisabled ? grey[700] : "#1364C0"}
            sx={{ textDecoration: "none", fontSize: "14px" }}
          >
            {link.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};
